var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "tower-info-list" }, [
    _c(
      "li",
      [
        _c("span", [_vm._v("经度:")]),
        _vm.edit
          ? _c("el-input", {
              on: { blur: e => _vm.handleBlur(e, "lon") },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return (e => _vm.handleBlur(e, "lon")).apply(null, arguments)
                }
              },
              model: {
                value: _vm.info.lon,
                callback: function($$v) {
                  _vm.$set(_vm.info, "lon", $$v)
                },
                expression: "info.lon"
              }
            })
          : _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.lon) || "-"))])
      ],
      1
    ),
    _c(
      "li",
      [
        _c("span", [_vm._v("纬度:")]),
        _vm.edit
          ? _c("el-input", {
              on: { blur: e => _vm.handleBlur(e, "lat") },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return (e => _vm.handleBlur(e, "lat")).apply(null, arguments)
                }
              },
              model: {
                value: _vm.info.lat,
                callback: function($$v) {
                  _vm.$set(_vm.info, "lat", $$v)
                },
                expression: "info.lat"
              }
            })
          : _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.lat) || "-"))])
      ],
      1
    ),
    _c(
      "li",
      [
        _c("span", [_vm._v("海拔:")]),
        _vm.edit
          ? _c("el-input", {
              on: { blur: e => _vm.handleBlur(e, "altitude") },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return (e => _vm.handleBlur(e, "altitude")).apply(
                    null,
                    arguments
                  )
                }
              },
              model: {
                value: _vm.info.altitude,
                callback: function($$v) {
                  _vm.$set(_vm.info, "altitude", $$v)
                },
                expression: "info.altitude"
              }
            })
          : _c("span", [
              _vm._v(_vm._s((_vm.info && _vm.info.altitude) || "-") + " m")
            ])
      ],
      1
    ),
    _vm.scene === "plan"
      ? _c("li", [
          _c("span", [_vm._v("折减系数:")]),
          _c("span", { staticStyle: { width: "95px" } }, [
            _vm._v(
              _vm._s((_vm.info && _vm.info.synthesizeLoss) || "-") + " (除尾流)"
            )
          ])
        ])
      : _c("li", [
          _c("span", [_vm._v("尾流折减:")]),
          _c("span", { staticStyle: { width: "95px" } }, [
            _vm._v(_vm._s((_vm.info && _vm.info.flowLoss) || "-") + " %")
          ])
        ]),
    _c("li", [
      _c("span", [_vm._v("理论发电量:")]),
      _c("span", { staticStyle: { width: "95px" } }, [
        _vm._v(_vm._s((_vm.info && _vm.info.annualEnergy) || "-") + " MWh")
      ])
    ]),
    _c("li", [
      _c("span", [_vm._v("满发小时数:")]),
      _c("span", [
        _vm._v(_vm._s((_vm.info && _vm.info.fullLoadHour) || "-") + " h")
      ])
    ]),
    _c("li", [
      _c("span", [_vm._v("平均风速:")]),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.wspd) || "-") + " m/s")])
    ]),
    _c("li", [
      _c("span", [_vm._v("平均气温:")]),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.t) || "-") + " ℃")])
    ]),
    _c("li", [
      _c("span", [_vm._v("A:")]),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.weibullA) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("K:")]),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.weibullK) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("功率密度:")]),
      _c("span", [
        _vm._v(_vm._s((_vm.info && _vm.info.powerDensity) || "-") + " W/㎡")
      ])
    ]),
    _c("li", [
      _c("span", [_vm._v("空气密度:")]),
      _c("span", [
        _vm._v(_vm._s((_vm.info && _vm.info.density) || "-") + " kg/m³")
      ])
    ]),
    _c("li", [
      _c("span", [_vm._v("风切变:")]),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.shear) || "-"))])
    ]),
    _c("li", [
      _c("span", [_vm._v("主风向:")]),
      _c("span", [_vm._v(_vm._s((_vm.info && _vm.info.mainDir) || "-"))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }